module.exports = __webpack_public_path__ + "img/snow.aa52a5d2.jpg";